import { Box, Container } from '@mui/material';
import { AppState, DefaultProps } from '../../types/types';

interface ImpressumProps extends DefaultProps {
    appState: AppState,
}

function Impressum(props:ImpressumProps) {
  

    return (
        <Box sx={{
            backgroundColor: 'footer.main' || '#0069b4',
            color: 'footer.contrastText' || '#4444',
            bottom: 0,
            padding: 0,
            margin: 0,
            width: '100%',
            paddingBottom: '12px',
            marginBottom: '-24px',
            paddingTop: '14px',
            textAlign: 'center',
            overflowX: 'hidden',
            overflowY: 'hidden',
            fontSize: { xs: '0.8em', sm: '1em', md: '1em', lg: '1em' },
            "& a:hover": {
                textDecoration: 'underline',
            },
            "& a": {
                textDecoration: 'none',
                color: 'primary.contrastText' || '#4444'
            },
        }}>
            <Container maxWidth="lg">
                Test
            </Container>
        </Box>
    );
}
export default Impressum;